import i18n from "@/i18n";

export enum DocumentPolicy {
    Private = 0,
    OrganizationAdmin = 1,
    Everyone = 2
}

export class DocumentPolicyHelper {
    static values(): string[] {
        return Object.keys(DocumentPolicy).filter((item) => isNaN(Number(item)))
    }

    static policiesValueAndNames(): any[] {
        return this.values().map((documentPolicy: string) => {
            return {
                name: Number(i18n.t(`document.policies.${documentPolicy.makeFirstLetterLowercase()}.value`)),
                label: i18n.t(`document.policies.${documentPolicy.makeFirstLetterLowercase()}.name`)
            }
        });
    }
}